<template>
  <div class="footer" ref="container">
    <b-container>
      <b-row>
        <b-col md="10" class="thanks-section mx-auto" v-lazy:background-image.container="footerBackground">
          <div class="thanks-message">
            THANKS FOR<br>
            ANOTHER<br>
            GREAT YEAR<br>
          </div>
        </b-col>
      </b-row>
      <b-row class="more-info">
        <b-col class="mx-auto" md="10">
          <a href="https://www.franchise.org"><span class="more-info-message">For more information, check us out at Franchise.org.</span></a>
          <p class="share-accomplishments">Click to share IFA's 2017 accomplishments.</p>
        </b-col>
      </b-row>
      <b-row class="social-media-section">
        <b-col class="mx-auto" md="10">
          <div class="social-media-wrapper">
            <ul class="social-media-list">
              <social-sharing url="https://www.franchise.org/2017-annual-report"
                      title="IFA 2017 Annual Report"
                      description="Learn more about the International Franchise Association's accomplishments in 2017, including their commitment to building relationships from Capitol Hill to the community."
                      quote="Read about the IFA's accomplishments in 2017, including proactively shaping policy and building relationships with Congress and the community."
                      network-tag="li"
                      inline-template>
                <network network="facebook" class="facebook-item" style="height:70px; width: 70px;list-style:none;display:inline-block;margin:0 10px;cursor:pointer;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="6492.942 7972.027 56.743 56.743"><g transform="translate(6492.942 7972.027)"><circle cx="28.372" cy="28.372" r="28.372" fill="#eaaa00"/><path d="M22.113 29.204v-4.338h3.254v-3.671a5.762 5.762 0 0 1 .334-2.086 4.765 4.765 0 0 1 1.085-1.752 6.371 6.371 0 0 1 1.919-1.253 6.767 6.767 0 0 1 2.754-.5 16.137 16.137 0 0 1 2.17.083l.834.083-.083 4.172h-2.754a1.8 1.8 0 0 0-1.5.5 2.117 2.117 0 0 0-.334 1.335v3.171h4.756l-.168 4.256h-4.507v11.934h-4.506V29.204z" fill="#fff"/></g></svg>
                </network>
              </social-sharing>
              <social-sharing url="https://www.franchise.org/2017-annual-report"
                        title="International Franchise Association 2017 Annual Report"
                        description="Read about the IFA's accomplishments in 2017, including proactive policy shaping and building relationships with Congress and the community."
                        quote="Read about the IFA's accomplishments in 2017, including proactive policy shaping and building relationships with Congress and the community."
                        hashtags="IFAAnnualReport"
                        network-tag="li"
                        inline-template>
                <network network="linkedin" class="linkedin-item" style="height:70px; width: 70px;list-style:none;display:inline-block;margin:0 10px;cursor:pointer;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="6567.208 7972.027 56.743 56.743"><g transform="translate(6567.209 7972.027)"><circle cx="28.372" cy="28.372" r="28.372" fill="#eaaa00"/><path d="M18.608 21.028a3.549 3.549 0 0 1 .167-.918 2.3 2.3 0 0 1 1.252-1.252 2.608 2.608 0 0 1 1.836 0 3.918 3.918 0 0 1 .751.5 1.97 1.97 0 0 1 .5.751 2.608 2.608 0 0 1 0 1.836 2.3 2.3 0 0 1-1.252 1.252 3 3 0 0 1-.918.167 1.8 1.8 0 0 1-.918-.167 2.3 2.3 0 0 1-1.252-1.252 3.549 3.549 0 0 1-.166-.917zm.083 16.606V25.368c0-.083.083-.083.083-.167.083-.083.083-.083.167-.083h3.839c.083 0 .083.083.167.083 0 .083.083.083.083.167v12.433c0 .083-.083.083-.083.167-.083.083-.083.083-.167.083h-3.755c-.083 0-.083-.083-.167-.083 0-.083-.083-.083-.083-.167s-.084-.083-.084-.167zm6.425 0V25.368c0-.083.083-.083.083-.167.083-.083.083-.083.167-.083h3.672c.083 0 .083 0 .167.083l.083.083a.291.291 0 0 1 .083.167v.5a3.841 3.841 0 0 1 1.5-.834 7.3 7.3 0 0 1 2-.25 5.928 5.928 0 0 1 2.17.334 4.09 4.09 0 0 1 1.669.918 3 3 0 0 1 1 1.5 5.215 5.215 0 0 1 .334 2.086v8.345c0 .083-.083.083-.083.167-.083.083-.083.083-.167.083h-3.915c-.083 0-.083-.083-.167-.083-.083-.083-.083-.083-.083-.167v-7.676a3.129 3.129 0 0 0-.083-.918 4.068 4.068 0 0 0-.25-.584 1.746 1.746 0 0 0-.5-.334 2.573 2.573 0 0 0-.834-.083 4.228 4.228 0 0 0-1.085.167 1.158 1.158 0 0 0-.668.584 2.346 2.346 0 0 0-.417.918 5.132 5.132 0 0 0-.084 1.168v6.843c0 .083-.083.083-.083.167s-.083.083-.167.083h-3.841c-.083 0-.083-.083-.167-.083-.083-.083-.083-.083-.083-.167-.25-.417-.25-.417-.25-.501z" fill="#fff"/></g></svg>
                </network>
              </social-sharing>
              <social-sharing url="https://www.franchise.org/2017-annual-report"
                        title="The International Franchise Association had a year of unprecedented accomplishments in 2017. Take a look at their annual report for a look into all they achieved for the franchise community."
                        hashtags="IFAAnnualReport"
                        twitter-user="franchising411"
                        network-tag="li"
                        inline-template>
                <network network="twitter" class="twitter-item" style="height:70px; width: 70px;list-style:none;display:inline-block;margin:0 10px;cursor:pointer;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="6641.475 7972.027 56.743 56.743"><g transform="translate(6641.475 7972.027)"><circle cx="28.372" cy="28.372" r="28.372" fill="#eaaa00"/><path d="M16.94 36.966c.167 0 .417.083.584.083h.584a12.449 12.449 0 0 0 1.752-.167 12.2 12.2 0 0 0 1.669-.417 11.822 11.822 0 0 0 1.5-.668 13.59 13.59 0 0 0 1.419-.918 4.858 4.858 0 0 1-1.585-.25 4.639 4.639 0 0 1-1.419-.751 6.67 6.67 0 0 1-1.085-1.085 4.427 4.427 0 0 1-.668-1.419 3.614 3.614 0 0 1 .417.083h.5a1.627 1.627 0 0 0 .668-.083c.25 0 .417-.083.668-.083a5.333 5.333 0 0 1-1.585-.668 8.425 8.425 0 0 1-1.335-1.085 4.376 4.376 0 0 1-.834-1.5 5.939 5.939 0 0 1-.334-1.752 4.192 4.192 0 0 0 1.085.417 5.635 5.635 0 0 0 1.168.167 4.037 4.037 0 0 1-1.585-1.752 6.069 6.069 0 0 1-.584-2.42 7.3 7.3 0 0 1 .167-1.335 2.926 2.926 0 0 1 .5-1.168 16.42 16.42 0 0 0 2.086 2.086 13.079 13.079 0 0 0 2.5 1.669 16.6 16.6 0 0 0 2.847 1.083 18.811 18.811 0 0 0 3 .5c0-.167-.083-.334-.083-.584v-.584a4.95 4.95 0 0 1 .417-1.919 4.145 4.145 0 0 1 1.084-1.587 4.892 4.892 0 0 1 1.582-1.083 5.015 5.015 0 0 1 4.005 0 5.512 5.512 0 0 1 1.669 1.168 5.538 5.538 0 0 0 1.669-.5 6.824 6.824 0 0 0 1.585-.751 5.771 5.771 0 0 1-.834 1.585 3.572 3.572 0 0 1-1.335 1.168 9.7 9.7 0 0 0 1.5-.334c.5-.167.918-.334 1.419-.5a9.605 9.605 0 0 1-1.168 1.419c-.417.417-.918.834-1.419 1.252v.668a16.017 16.017 0 0 1-.918 5.09 13.478 13.478 0 0 1-2.754 4.59 13.8 13.8 0 0 1-4.506 3.338 14.314 14.314 0 0 1-6.175 1.335 17.566 17.566 0 0 1-2.086-.167 17.089 17.089 0 0 1-2-.417 7.083 7.083 0 0 1-1.836-.751c-.581-.335-1.416-.669-1.916-1.003z" fill="#fff"/></g></svg>
                </network>
              </social-sharing>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      footerBackground: {
        src: '/2017-annual-report/static/images/2017.jpg',
        loading: '/2017-annual-report/static/images/2017_loading.jpg'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../global.scss";
#app .footer {
  margin: 0;
  padding: 0;
  background-color: rgb(20, 27, 77);
  .container {
    background-color: white;
    padding-top: 100px;
    .row {
      margin: 0;
    }
    .thanks-section {
      height: 225px;
      text-align: center;
      background-repeat: no-repeat;
      background-color: white;
      background-size: contain;
      background-position: center;
      @media all and (min-width: $md){
        height: 350px;
        // margin-bottom: -50px;
      }
      .thanks-message {
        color: #1E22AA;
        font-weight:800;
        text-align: center;
        text-transform: uppercase;
        display: block;
        position: relative;
        font-size: 35px;
        line-height: 44px;
        margin-top: 45px;
        @media all and (min-width: $md){
          line-height: 85px;
          font-size: 73px;
        }
      }
    }
    .social-media-section {
      background-color: white;
      margin: 0px auto;
      .social-media-list {
        text-align: center;
        div {
          list-style-image: none;
          text-align: center;
          display: inline-block;
          margin: 0 auto;
          a {
            padding-top: 20px;
            text-indent: 100%;
          	white-space: nowrap;
          	overflow: hidden;
            display: inline-block;
            margin: 0;
            text-align: center;
            width: 45px;
          }
        }
        li.custom-tweet {
          height: 70px;
          width: 70px;
          list-style: none;
          display: inline-block;
          margin: 0px 10px;
          cursor: pointer;
        }
      }
    }
    .more-info {
      background-color: white;
      padding: 50px 0 10px 0;
      span {
        font-size: 25px;
        line-height: 34px;
        color: $dark_gray;
        font-weight: bold;
        text-align: center;
        display: block;
        margin: 0 auto;
        max-width: 80%;
        @media all and (min-width: $md){
          font-size: 29px;
          max-width: none;
        }
      }
      a {
        color: $dark_gray;
        &:active, &:hover {
          text-decoration-color: $dark_gray;
        }
      }

      .share-accomplishments {
        font-size: 16px;
        font-weight: bold;
        padding-top: 20px;
        text-align: center;
        @media all and (min-width: $md){
          font-size: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue